<template>
  <div class="vx-row mb-2 -mt-1 dropDown" v-if="showDataField">

    <div class="vx-col" :class="calculateSize">
      <span class="text-xs">{{ fieldLabel }} </span>
      <v-select @search="fetchOptions" class="w-full" :label-placeholder="fieldLabel" name="field"
        v-validate="structure.validation" v-model="selected" :appendToBody="appendToBody" :options="dataOptions"
        :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      <span class="text-danger text-sm" v-show="errors.has('field')">{{
        errors.first("field")
      }}</span>
    </div>


  </div>
</template>
<script>
import vSelect from "vue-select";
import { helperMixin } from "../../../mixin/helperMixin";
import { sidebarMixin } from "../sidebarMixin";
import axios from "@/axios.js";
import { axiosMixin } from "@/mixin/axiosMixin.js";
import { bus } from "../../../main";

export default {
  mixins: [helperMixin, sidebarMixin, axiosMixin],
  components: {
    vSelect,
  },
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => { },
      required: true,
    },
    value: String, // change from Number to String because of PR branch
    validation: "",
    size: String,
    appendToBody: {
      type: Boolean,
      defaul: false,
    },
  },
  data() {
    return {
      selected: this.thevalue,
    };
  },
  computed: {
    thevalue() {
      return this.value != null ? JSON.parse(this.value).id : "";
    },
    calculateSize() {
      return this.size == undefined ? "w-full" : this.size;
    },

    showDataField() {
      return this.showField();
    },
    dataOptions() {
      if (this.index == 'subStockCode') {
        return this.$store.state.main.subStockCodeFilter

      } else {
        return this.structure.data;
      }
    }
  },
  methods: {
    fetchOptions(search, loading) {
      loading(true)
      // fetch data from server

      if (this.index == 'subStockCode') {

        this.aronPost("getsubStockCodeBaseOnMasterStockCode", { mtc: this.$store.state.main.masterStockCodeValue, ssc: search }, "", "")
          .then((response) => {
            if (response.status == 200) {
              this.$store.state.main.subStockCodeFilter = response.data.data;
              loading(false)
            }
          })
          .catch((error) => {
            // this.decodeErrorFromAxios(error);
          });
      }




    }
  },
  created() {
    if (this.value != undefined && this.value != "") {
      this.selected = this.arrayOfObjectFind(
        this.structure.data,
        this.value
      )[0];

      this.$emit("input", { index: this.index, value: this.value });
    } else {
      this.selected = this.arrayOfObjectFind(
        this.structure.data,
        this.structure.value
      )[0];

      this.$emit("input", { index: this.index, value: this.structure.value });
    }


    if (this.selected != "" && this.selected != undefined) {
      this.$emit("error", { index: this.index, value: true });
    }
    // if (this.index == 'subStockCode') {
    //   this.$watch("$store.state.main.subStockCodeFilter", (value) => {
    //     this.selected = '';
    //   });
    // }
    this.$watch("selected", (value) => {
      var errorVal = false;
      if (value != null) {
        errorVal = true;
        value = value.id;
      }

      //custom code for hawk case. remove it when not needed
      if (this.index == "gasketTypeFilter") {

        this.aronPost("getMasterCodeBaseOnGasgetType", { gasketType: value, getMasterCodeBaseOnGasgetType: '' }, "", "")
          .then((response) => {
            if (response.status == 200) {
              this.$store.state.main.gasketTypevalue = value;
              this.$store.state.main.masterCodeWarehouseFilter = response.data.data;
            }
          })
          .catch((error) => {
            // this.decodeErrorFromAxios(error);
          });
      }

      this.$emit("error", { index: this.index, value: errorVal });
      this.$emit("input", { index: this.index, value: value });
    });
  },
};
</script>
<style lang="scss" scoped>
.dropDown {}
</style>
